import { Link } from 'react-router-dom';
import { siteDetails } from '../lib/site';
import { Logo } from './Logo';

export const SiteFooter = () => (
  <footer className="border-t border-white/10 bg-[#000210] px-5 py-12 text-white">
    <div className="mx-auto grid max-w-7xl gap-10 md:grid-cols-[1.35fr_0.65fr_0.65fr]">
      <div className="max-w-md">
        <Logo variant="transparent" className="h-10 w-auto" />
        <p className="mt-5 leading-7 text-white/62">
          Self-service software for creating browser-based AR experiences and measuring engagement
          with physical media.
        </p>
        <p className="mt-4 text-sm text-white/52">
          Payments are processed by Paddle, our Merchant of Record, which manages payment-related
          buyer support, applicable sales taxes, and returns.
        </p>
      </div>
      <div>
        <h2 className="text-sm font-semibold uppercase tracking-[0.16em] text-blue-200">Product</h2>
        <div className="mt-4 flex flex-col gap-3 text-sm text-white/64">
          <a className="transition hover:text-white" href="/#how-it-works">
            How it works
          </a>
          <Link className="transition hover:text-white" to="/pricing">
            Pricing
          </Link>
          <Link className="transition hover:text-white" to="/contact">
            Buyer support
          </Link>
        </div>
      </div>
      <div>
        <h2 className="text-sm font-semibold uppercase tracking-[0.16em] text-blue-200">Legal</h2>
        <div className="mt-4 flex flex-col gap-3 text-sm text-white/64">
          <Link className="transition hover:text-white" to="/terms">
            Terms
          </Link>
          <Link className="transition hover:text-white" to="/privacy">
            Privacy
          </Link>
          <Link className="transition hover:text-white" to="/refunds">
            Refund policy
          </Link>
          <a className="transition hover:text-white" href={`mailto:${siteDetails.supportEmail}`}>
            {siteDetails.supportEmail}
          </a>
        </div>
      </div>
    </div>
    <div className="mx-auto mt-10 flex max-w-7xl flex-col gap-2 border-t border-white/10 pt-6 text-sm text-white/42 sm:flex-row sm:items-center sm:justify-between">
      <p>© {new Date().getFullYear()} {siteDetails.brandName}. All rights reserved.</p>
      <p>Software subscriptions and usage-based scan packs.</p>
    </div>
  </footer>
);

